import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconUnderline = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M7.62158 17.1738H16.3784"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.61182 6.8252V13.1938C9.61182 14.5128 10.6811 15.582 12 15.582C13.319 15.582 14.3882 14.5128 14.3882 13.1938V6.8252"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconUnderline.displayName = 'IconUnderline';
